import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=a699e92a&scoped=true&"
import script from "./rules.vue?vue&type=script&lang=js&"
export * from "./rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a699e92a",
  null
  
)

export default component.exports